// Tooltip sizing in DESIGN pixels (multiplied by canvasScale at use-site).
// CSS gives the tooltip a 20cqw minimum width, 320 design-px at the
// 1600px design canvas; a long skill name widens it, and the caller
// passes the measured width once it has rendered.
export const TOOLTIP_W = 320;
export const TOOLTIP_H_EST = 140;
const TOOLTIP_MARGIN = 18;
const VIEWPORT_PAD = 16;
const DESIGN_WIDTH = 1600;

function canvasRect() {
  if (typeof document === 'undefined') return null;
  return document.querySelector('.app-canvas')?.getBoundingClientRect() || null;
}

export function getCanvasScaleNow() {
  return (canvasRect()?.width || DESIGN_WIDTH) / DESIGN_WIDTH;
}

// Compute a clamped position for a tooltip given an anchor rect and the
// tooltip's rendered height, both in viewport pixels. The tooltip is
// rendered with `position: fixed` inside `.app-canvas`, which is a
// containing block (transform: translateZ(0)), so the returned left/top
// are canvas-local. All sizing math is multiplied by canvasScale so the
// JS-side clamp matches the cqw-driven rendered dimensions. `width` is
// the rendered width in viewport pixels; before the first paint the
// minimum width stands in for it. `above` skips the side placement and
// centres the tooltip over the anchor, for anchors on a horizontal strip.
export function positionTooltip(rect, height = TOOLTIP_H_EST, width = null, { above = false } = {}) {
  if (!rect) return null;
  const canvas = canvasRect() || { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
  const canvasW = canvas.width;
  const canvasH = canvas.height;
  const canvasScale = canvasW / DESIGN_WIDTH;

  const localLeft = rect.left - canvas.left;
  const localTop = rect.top - canvas.top;
  const localRight = rect.right - canvas.left;
  const localBottom = rect.bottom - canvas.top;
  const cx = localLeft + rect.width / 2;
  const cy = localTop + rect.height / 2;

  const tooltipW = width || TOOLTIP_W * canvasScale;
  const margin = TOOLTIP_MARGIN * canvasScale;
  const pad = VIEWPORT_PAD * canvasScale;

  let left = localRight + margin;
  let top = cy - height / 2;

  if (!above && left + tooltipW > canvasW - pad) {
    left = localLeft - tooltipW - margin;
  }
  if (above || left < pad) {
    left = cx - tooltipW / 2;
    if (localTop - height - margin > pad) {
      top = localTop - height - margin;
    } else {
      top = localBottom + margin;
    }
  }

  left = Math.max(pad, Math.min(left, canvasW - tooltipW - pad));
  top = Math.max(pad, Math.min(top, canvasH - height - pad));
  return { left, top };
}
